// extracted by mini-css-extract-plugin
module.exports = {"tabs":"StagesRowSelect_tabs__13CU0","tab":"StagesRowSelect_tab__3ZtSb","tabActive":"StagesRowSelect_tabActive__EeZ_j","icon":"StagesRowSelect_icon__nU9AI"};